module.exports = __webpack_public_path__ + "img/shot-3.63f51ccd.png";